import { AnnouncementApi } from "api/announcement";
import { SeoType } from "api/announcement/type";
import { isBajiGold } from "contants/common";
import { utilChangeSeoId } from "helpers/utilChangeSeoId";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

type Props = {
  title?: string | undefined;
};

function HelmetCustom(props: Props) {
  const [data, setData] = useState<SeoType[]>([]);

  const seo_id = utilChangeSeoId(window.location.pathname) || "";

  const fetDataSEO = async () => {
    try {
      const res = await AnnouncementApi.getSeo({ seo_id: seo_id });
      if (res.data.status === 200) {
        setData(res.data.data);
      }
    } catch (error) {
      // alert.showAlert(error + "", "error");
      console.log("error", error + "");
    }
  };
  useEffect(() => {
    if (!!seo_id.length) {
      fetDataSEO();
    }
  }, [seo_id]);

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>
        {data[0]?.page_title || window.location.hostname.split(".")[0]}
      </title>
      <meta name="description" content={data[0]?.meta_descriptions || ""} />
      <meta name="keywords" content={data[0]?.meta_keywords || ""} />
      <meta
        property="og:title"
        content={data[0]?.meta_header || window.location.hostname.split(".")[0]}
      />
      <meta
        property="og:description"
        content={data[0]?.meta_descriptions || ""}
      />
      <link rel="icon" type="image/x-icon" href={"/favicon.ico"} sizes="any" />
    </Helmet>
  );
}

export default HelmetCustom;
